<div class="menu-category-option">
  <div [ngClass]="{'category-divider': !isLast}">
    <h3 class="category-option-title">{{ translationKey | translate }}</h3>

    <ul id="subOptionContainer" class="sub-option-container">
      <li id="subOption{{i}}" *ngFor="let subOption of subOptions; index as i" >
        <div *ngIf="subOption.tipoMenu == 6" class="option-with-ellipsis link-sub-option" >
          <ng-container *ngIf="subOption.url.includes('iservices')">
            <a href="JavaScript:void(0);" [attr.tabindex]="initialIndex" (click)="goToiServices(subOption.url)" class="link-no-decoration" [matTooltip]="subOption.translationKey + '.TRANSLATION' | translate" [matTooltipClass]="'my-tooltip'">
              {{ subOption.translationKey + ".TRANSLATION" | translate }}
            </a>
          </ng-container>
          <ng-container *ngIf="!subOption.url.includes('iservices')">
            <a [href]="subOption.url" target="_blank" [attr.tabindex]="initialIndex" class="link-no-decoration" [matTooltip]="subOption.translationKey + '.TRANSLATION' | translate" [matTooltipClass]="'my-tooltip'">
              {{ subOption.translationKey + ".TRANSLATION" | translate }}
            </a>
          </ng-container>
        </div>
        <div *ngIf="subOption.tipoMenu == 5" class="option-with-ellipsis link-sub-option" >
          <ng-container *ngIf="subOption.url.includes('iservices')">
            <a href="JavaScript:void(0);" [attr.tabindex]="initialIndex" (click)="goToiServices(subOption.url)" class="link-no-decoration" [matTooltip]="subOption.translationKey + '.TRANSLATION' | translate" [matTooltipClass]="'my-tooltip'">
              {{ subOption.translationKey + ".TRANSLATION" | translate }}
            </a>
          </ng-container>
          <ng-container *ngIf="!subOption.url.includes('iservices')">
            <a href="JavaScript:void(0);" [attr.tabindex]="initialIndex" (click)="openModalContext(subOption)" class="link-no-decoration" [matTooltip]="subOption.translationKey + '.TRANSLATION' | translate" [matTooltipClass]="'my-tooltip'">
              {{ subOption.translationKey + ".TRANSLATION" | translate }}
            </a>
          </ng-container>
        </div>
        <div *ngIf="subOption.tipoMenu != 5 && subOption.tipoMenu != 6" class="option-with-ellipsis link-sub-option" >
          <a href="JavaScript:void(0);" [attr.tabindex]="initialIndex" (click)="openModal(subOption)" (click)="submitEvent(subOption.name)" class="link-no-decoration" [matTooltip]="subOption.translationKey + '.TRANSLATION' | translate" [matTooltipClass]="'my-tooltip'">
            {{ subOption.translationKey + ".TRANSLATION" | translate }}
          </a>
        </div>
      </li>
    </ul>
  </div>

  <ul class="sub-option-container">
    <li class="all-options">
        <span id="openFullOption" [attr.tabindex]="initialIndex"  (click)="openFullMenu()" (keydown.enter)="openFullMenu()" class="all-options-text pointer" *ngIf="hasManySubOptions">{{ 'seeAllOptions.TITLE' | translate }}</span>
    </li>
  </ul>

</div>
